import { useContext, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { RoutesNames } from "../components/utils/routes";
import { GlobalContext } from "../context/GlobalContext";

export const useRedirectLogged = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, rol, user, setToken, setRol, setUser } = useContext(GlobalContext);

  const restoreToken = useCallback(() => {
    const restoredToken = window.sessionStorage.getItem("secret_key");
    if (restoredToken) {
      setToken(restoredToken);
    }
  }, [setToken]);

  const restoreRole = useCallback(() => {
    const restoredRole = window.localStorage.getItem("rol_user");
    if (restoredRole) {
      setRol(restoredRole);
    }
  }, [setRol]);

  const restoreUser = useCallback(() => {
    const restoredUser = window.localStorage.getItem("name_user");
    if (restoredUser) {
      setUser(restoredUser);
    }
  }, [setUser]);

  const redirectToRoleBasedPage = useCallback(() => {
    navigate(RoutesNames.main);
  }, [navigate]);

  useEffect(() => {
    // Restaurar token, rol y usuario si no están ya definidos
    if (!token) restoreToken();
    if (!rol) restoreRole();
    if (!user) restoreUser();

    // Verificar si es necesario redirigir
    if (token && rol) {
      if (location.pathname === RoutesNames.login) {
        redirectToRoleBasedPage();
      }
    }
  }, [token, rol, user, restoreToken, restoreRole, restoreUser, location.pathname, redirectToRoleBasedPage]);
};
